// src/components/Shared/AppDownload.jsx
import React from 'react';
import { Modal, Button } from 'antd';

const AppDownload = () => {
  return (
    <Modal
      title="Lo sentimos"
      visible={true}
      footer={[
        <Button key="close" onClick={() => window.location.reload()}>
          Cerrar
        </Button>
      ]}
    >
      <p>Lo sentimos mucho, pero por el momento no es posible descargar la app de Mercanteomexico, pero estará disponible pronto!</p>
    </Modal>
  );
};

export default AppDownload;
